export default function Slash() {
  return (
    <>
      <span className="toji-slash" aria-hidden="true" />
      <span className="toji-slash thin" aria-hidden="true" />
    </>
  );
}
